export default __webpack_public_path__ + "static/media/status.4bc3d6fa.svg";